import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from 'src/store';
import useCurrentUser from 'src/store/user/useCurrentUser';

export const useSprinklrIntegrationEnabled = () => {
  const customer = useCurrentCustomer();
  const user = useCurrentUser();

  const flag = BE_CUSTOMER_FEATURES.sprinklrIntegrationEnabled;
  return isCustomerFeatureEnabled(customer, flag) || (user?.featureFlags ?? []).includes(flag);
};
